// Error handling utilities
export const normalizeToError = (
  error: unknown,
  fallbackMessage: string
): Error => {
  if (error instanceof Error) {
    return error
  }

  if (error && typeof (error as { message?: unknown }).message === 'string') {
    return new Error((error as { message: string }).message)
  }

  if (typeof error === 'string') {
    const trimmed = error.trim()
    return new Error(trimmed.length > 0 ? trimmed : fallbackMessage)
  }

  return new Error(fallbackMessage)
}

// URL parameter building utilities
export const buildSearchParams = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams()

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      if (typeof value === 'number' || typeof value === 'boolean') {
        searchParams.append(key, String(value))
      } else if (typeof value === 'string') {
        searchParams.append(key, value)
      }
    }
  }

  return searchParams.toString()
}

export const buildUrlWithParams = (
  endpoint: string,
  params: Record<string, any>
): string => {
  const queryString = buildSearchParams(params)
  return queryString ? `${endpoint}?${queryString}` : endpoint
}

// Type guards for API responses
export const isErrorResponse = (data: any): data is { error: string } =>
  typeof data === 'object' && data !== null && typeof data.error === 'string'

export const isSuccessResponse = (data: any): data is { success: boolean } =>
  typeof data === 'object' && data !== null && typeof data.success === 'boolean'
